import { Chip, ChipProps  } from "@mui/material";
import React, { Component } from "react";
import styled from "styled-components";

interface CustomChipProps extends ChipProps {
    // Define any additional props or styles here
    rgbcolor:any, active?:boolean
  }

export const ColourChip = styled(Chip)<CustomChipProps>`
    display: inline-block;
    align-items: center;
    height: 22px!important;
    white-space: nowrap;  
    padding: 1px!important;
    cursor: pointer;
    font-size: 0.875rem!important;
    background-color: ${(props) => props.rgbcolor}!important;
    opacity: ${(props) => props.active ? '0.5' : '1'}!important;
    color: white!important;
    border:none;
    .MuiChip-avatar {
        /* Set the color you want for the icon */
        color: white!important; /* Replace 'red' with your desired color */
    }
`;

const ColourButtonComponent = styled.span<CustomChipProps>`
    display: inline-block;
    align-items: center;
    height: 22px!important;
    width:22px;
    padding-top:0.1rem;
    padding-left:0.15rem;
    background-color: ${(props) => props.rgbcolor}!important;
    opacity: ${(props) => props.active ? '0.5' : '1'}!important;
    color: white!important;
    border-radius: 50%;
`;



export const ColourButton = (props) => {
    const iconStyles = {color:'#fff', fontSize:'1.1rem', textAlign:'center'}
    // SHER-426: cloneElement throws React #267 ("must be a React element, but you
    // passed undefined") when props.icon is not a valid element — e.g. an enum value
    // a status/type-to-icon mapper doesn't handle. That crash latched the page's
    // ErrorBoundary ("Something went wrong") and white-screened the whole billing
    // table. Guard so a missing icon degrades to an empty coloured chip instead.
    const ClonedElementWithMoreProps = React.isValidElement(props.icon)
        ? React.cloneElement(props.icon, { style : iconStyles})
        : null;
    return (
        <ColourButtonComponent {...props}>
            { ClonedElementWithMoreProps }
        </ColourButtonComponent>
    );
};
// export const ColourChip = (props:any) => {
//     const [selected, setSelected] = React.useState(false);
//     function onClick(){
//         setSelected(!selected);
//         props.onClick();
//     }
//     return <ColourChipButton selected={selected} onClick={onClick} />
// }